import React from 'react';
import { styled, css } from 'styled-components';
import { breakpoints } from '../../../abstracts';
import { BaseTemplateStyles, BasePageTitleContainer, BaseMainPanelContainer, StyledButtonGroup, BaseMainContentContainer } from '../elements';
import { BaseSidePanelContainer } from './SidePanelContainer';
import { dontForwardProps } from '../../../util';
const getGrid = breakpoint => ({
  progressStepper,
  mobileSidebarPosition,
  hasButtonGroup
}) => {
  let templateAreas = [];
  let templateRows = [];
  if (breakpoint === 'mobile' && hasButtonGroup && progressStepper) {
    templateAreas.push('progress-stepper');
    templateRows.push('auto');
  }
  if (mobileSidebarPosition === 'top') {
    templateAreas = ['side-panel', ...templateAreas, 'main-content'];
    templateRows = ['auto', ...templateRows, '1fr'];
  } else if (mobileSidebarPosition === 'after-heading') {
    templateAreas.push('page-title', 'side-panel', 'main-panel');
    templateRows.push('auto', 'auto', '1fr');
  } else if (mobileSidebarPosition === 'bottom') {
    templateAreas.push('main-content', 'side-panel');
    templateRows.push('auto', '1fr');
  } else if (mobileSidebarPosition === 'none') {
    templateAreas.push('main-content');
    templateRows.push('1fr');
  }
  if (hasButtonGroup) {
    templateAreas.push('button-group');
    templateRows.push('auto');
  }
  return css(["grid-template-areas:", ";grid-template-rows:", ";"], templateAreas.map(area => `'${area}'`).join('\n'), templateRows.join(' '));
};
const getDesktopGridTemplateAreas = ({
  mobileSidebarPosition,
  hasButtonGroup
}) => {
  const templateAreas = [];
  if (mobileSidebarPosition === 'after-heading') {
    templateAreas.push('page-title', 'main-panel');
  } else {
    templateAreas.push('main-content');
  }
  if (hasButtonGroup) {
    templateAreas.push('button-group');
  }
  return templateAreas.map(area => `'${area} side-panel'`).join('\n');
};
export const BaseFlexTemplate = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1pm7i7o-0"
})(["", " ", " padding-top:var(--aui-spacing-300);", " box-sizing:border-box;", ";", ";", ";", "{padding-left:var(--aui-spacing-300);padding-right:var(--aui-spacing-300);padding-top:var(--aui-spacing-600);", "}", "{", ";height:calc(100vh - ", ");grid-template-areas:", ";grid-template-columns:7fr 5fr;grid-template-rows:", ";padding-left:var(--aui-spacing-600);padding-right:var(--aui-spacing-600);padding-top:unset;padding-bottom:unset;", "{display:unset;}}", "{column-gap:var(--aui-spacing-600);margin-left:auto;margin-right:auto;}"], BaseTemplateStyles, getGrid('mobile'), p => p.upperVerticalOffset && css(["min-height:calc(100vh - ", ");"], p.upperVerticalOffset), p => !p.hasButtonGroup && css(["padding-bottom:var(--aui-spacing-600);"]), p => p.mobileSidebarPosition === 'none' && css(["", "{display:none;}"], BaseSidePanelContainer), p => p.mobileSidebarPosition === 'after-heading' && css(["", "{padding-bottom:3rem;}"], BaseMainPanelContainer), breakpoints.md, getGrid('md'), breakpoints.md2, p => p.mobileSidebarPosition === 'after-heading' && css(["overflow-y:auto;"]), props => props.upperVerticalOffset, getDesktopGridTemplateAreas, props => props.mobileSidebarPosition === 'after-heading' ? 'auto 1fr' : '1fr', BaseSidePanelContainer, breakpoints.xl);

// Have to wrap with React component (not just styled-components) for getChildByType to work
export const MainContentContainer = ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement(BaseMainContentContainer, props, children);
export const PageTitleContainer = styled(BasePageTitleContainer).withConfig({
  componentId: "aui__sc-1pm7i7o-1"
})(["", "{margin-top:var(--aui-spacing-600);}", "{margin-right:0;}"], breakpoints.md2, breakpoints.xl);
export const MainPanelContainer = styled(BaseMainPanelContainer).withConfig({
  componentId: "aui__sc-1pm7i7o-2"
})(["", "{margin-right:0;}"], breakpoints.xl);
export const ButtonGroup = styled(StyledButtonGroup).withConfig({
  componentId: "aui__sc-1pm7i7o-3"
})(["", "{width:100%;}"], breakpoints.md2);